import { createFileRoute } from '@tanstack/react-router';

import { PcbSettingsPage } from '@/areas/settings/pcb/OrganizationSettings/PcbPage/PcbSettingsPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/pcb/')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbSettingsPage />;
}
